import {
  Flex,
  IconChevronRight,
  IconCircleCheckFilled,
  Typography,
  useScreenSize,
} from '@banhala/ui-kit';
import type { BannerProps } from '../types';

export const Banner = ({
  handleClickOfficialMarketBanner,
  officialMarket: {
    item: { deeplink, market_name },
    logging,
  },
}: BannerProps) => {
  const { width } = useScreenSize();
  return (
    <Flex.Row
      onPress={() => {
        handleClickOfficialMarketBanner({ market_name, deeplink }, logging);
      }}
      width={width - 32}
      margin={{ horizontal: 16 }}
      backgroundColor="lilac5"
      borderRadius={'small'}
      padding={{ horizontal: 12, vertical: 12 }}
      gap={8}
      alignItems="center"
    >
      <IconCircleCheckFilled width={16} height={16} fill="rgb(37, 114, 247)" />
      <Typography type="subtitle3" color="content_primary">
        공식 {market_name} 마켓 바로가기
      </Typography>
      <IconChevronRight width={12} height={12} />
    </Flex.Row>
  );
};
